import React, { useMemo } from "react";
import { Tooltip as TooltipAnT } from "antd";
import { useSelector } from "react-redux";
import { getLineColor } from "../../../utils/getLineColor";

export const QuantitativeMetadataBarChart = ({ chartData, handlePieClick, nps = false, numberBreakdown = false }) => {
    const totalValue = chartData.reduce((acc, concept) => acc + concept.value, 0);
    const colorScheme = [
        "rgba(232,75,75,0.68)",
        "rgba(232,75,75,0.68)",
        "rgba(232,75,75,0.68)",
        "rgba(232,75,75,0.68)",
        "rgba(232,75,75,0.68)",
        "rgba(232,75,75,0.68)",
        "rgba(232,75,75,0.68)",
        "#f3c939",
        "#f3c939",
        "#36b1e8",
        "#36b1e8",
    ];
    const colorSchemeBreakdown = [
        "rgba(246,74,74,0.9)",
        "rgba(244,113,113,0.8)",
        "rgba(242,151,151,0.7)",
        "rgba(240,189,189,0.6)",
        "rgba(248,224,224,0.5)",
        "rgba(255,255,255,1)",
        "rgba(200,224,255,0.5)",
        "rgba(145,190,255,0.6)",
        "rgba(88,156,255,0.7)",
        "rgba(44,122,255,0.8)",
        "rgba(0,88,255,0.9)",
    ];

    const chartColors = useMemo(() => {
        if (numberBreakdown) {
            const step = Math.max(Math.floor(colorSchemeBreakdown.length / chartData.length), 1);
            return chartData.map((_, index) => colorSchemeBreakdown[index * step] || colorSchemeBreakdown[colorSchemeBreakdown.length - 1]);
        } else {
            return chartData.map((_, index) => getLineColor(index));
        }
    }, [chartData, numberBreakdown]);

    const npsChartColors = useMemo(() => {
        const step = Math.max(Math.floor(colorScheme.length / chartData.length), 1);
        return chartData.map((_, index) => colorScheme[index * step] || colorScheme[colorScheme.length - 1]);
    }, [chartData]);

    const height = "58px";
    return (
        <div style={{ display: "flex", flexDirection: "column-reverse", padding: "2%" }}>
            <div
                style={{
                    height,
                    width: "100%",
                    display: "flex",
                    backgroundColor: "#fff",
                    columnGap: "1px",
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                    overflow: "hidden",
                }}
            >
                {chartData.map((concept, index) => (
                    <TooltipAnT
                        key={index}
                        title={
                            <div>
                                <strong>{concept.name}</strong>: {(concept.value * 100).toFixed(2)}%
                            </div>
                        }
                    >
                        <div
                            onMouseDown={e => e.stopPropagation()}
                            style={{
                                height,
                                width: `${(concept.value / totalValue * 100).toFixed(2)}%`,
                                background: nps ? npsChartColors[index] : chartColors[index],
                                borderRadius: "0 2px 2px 0",
                                cursor: "pointer",
                            }}
                            onClick={() => handlePieClick(concept)}
                        />
                    </TooltipAnT>
                ))}
            </div>
            <div style={{
                width: "100%",
                overflowY: "auto",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "center",
                padding: "10px",
            }}>
                <CustomLegend
                    nps={nps}
                    payload={chartData.map((entry, index) => ({
                        color: nps ? npsChartColors[index] : chartColors[index],
                        payload: entry,
                    }))}
                    onClick={handlePieClick}
                />
            </div>
        </div>
    );
};

const CustomLegend = ({ payload, onClick, nps }) => {
    const labelFontSize = useSelector((state) => {
        const fontSizes = state.fontManager.fontSizes;
        const normalizedKey = Object.keys(fontSizes).find(
            (key) => key.trim() === "labelFontSize",
        );
        return fontSizes[normalizedKey] || 16;
    });

    return (
        <div

            style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                margin: "0 auto",
                flexWrap: "wrap",
                maxWidth: "100%",
            }}>
            {payload.map((entry, index) => (
                <TooltipAnT
                    title={`${entry.payload.name} - ${(entry.payload.value * 100).toFixed(0)}%`}
                    key={`item-${index}`}
                >
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            margin: "5px 10px",
                            cursor: "pointer",
                            maxWidth: "100%",
                            overflow: "hidden",
                        }}
                        onMouseDown={e => e.stopPropagation()}
                        onClick={() => onClick(entry.payload)}
                    >
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="7" cy="7" r="4.375" style={{ fill: entry.color }} />
                        </svg>

                        <span style={{
                            fontWeight: "bold",
                            fontSize: labelFontSize,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        }}>
                            {entry.payload.name} {!nps && <span> - {(entry.payload.value * 100).toFixed(0)}%</span>}
                        </span>
                    </div>
                </TooltipAnT>
            ))}
        </div>
    );
};
